import Translation from "@Translation/components/Translation";
import {
    singleModalTranslationKey
} from "@SearchResults/features/staticContent/constants/translationKeys";
import OperatorsList from "@SearchResults/features/staticContent/components/OperatorsList";

interface CompaniesOperatingContentProps {
    departure: string,
    destination: string,
    availableTransportation: string,
    operators: string[]
}

function CompaniesOperatingContent(props: CompaniesOperatingContentProps) {
    const {
        departure,
        destination,
        availableTransportation,
        operators,
    } = props

    return (
        <OperatorsList
            title={(
                <Translation
                    translationKey={`${singleModalTranslationKey}.companies_operating.title`}
                    translationVariables={{departure, destination, availableTransportation}}
                />
            )}
            operators={operators}
        />
    )
}

export default CompaniesOperatingContent